import { erpAxios } from '..';

const editLoanApplication = async (data) => {
  const res = await erpAxios.post(`/loanApplication/edit`, data);
  return res ? res : null;
};

export default editLoanApplication;
